import axios from 'axios'
import Cookies from 'js-cookie'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import { ServiceAtom } from '../../recoil/atoms'

interface GetSiteListResponse {
  // address: string
  // address2: string
  // city: string
  // hasVisitCamera: number
  name: string
  // numOfBeacons: number
  // numOfFloors: number
  // postalCode: string
  // prefecture: string
  // serviceID: number
  // siteDays: string
  // siteDescription: string
  // siteHour: string
  siteID: number
}

const useGetSiteList = () => {
  const service = useRecoilValue(ServiceAtom)
  const accessToken = Cookies.get('LoginToken')

  const fetcher = (url: string): Promise<GetSiteListResponse[]> => axios.get(url).then((res) => res.data.sites)
  const { data, isLoading } = useSWR(
    () =>
      service.value !== '' && accessToken
        ? `${process.env.REACT_APP_API_DOMAIN}/1/Console/GetSiteList?accessToken=${accessToken}&serviceID=${service.value}&counts=1`
        : null,
    fetcher,
    { revalidateOnFocus: false, revalidateOnReconnect: false, shouldRetryOnError: false },
  )

  return { sites: data, sitesLoading: isLoading }
}

export default useGetSiteList
